module.exports = "/_next/static/images/manohar-a1fc9782c00a727d80b1dfc3182edb5e.png";